
import Vue from 'vue';
import SchoolVerificationService from '~/services/SchoolVerificationService';

export default Vue.extend({
    name: 'SchoolNotFoundInfo',
    props: {
        programId: {
            type: String || null,
            required: false,
            default: null,
        },
    },
    data() {
        return {
            isLoading: false,
            verificationService: new SchoolVerificationService(),
        };
    },
    computed: {
        style(): string {
            return 'warning';
        },
        headerKey(): string {
            return this.buildTranslationKey('schoolNotFound');
        },
        textKey(): string {
            if (!this.programId) {
                return this.buildTranslationKey('schoolNotFoundDescription');
            }

            return this.buildTranslationKey('schoolNotFoundDoubleCheck');
        },
        primaryActionKey(): string | null {
            return this.buildTranslationKey('findMySchool');
        },
    },
    methods: {
        editProgram() {
            this.$emit('edit', this.programId);
        },
        buildTranslationKey(key: string): string {
            return `shared.schoolVerification.${key}`;
        },
    },
});
